module.exports = __webpack_public_path__ + "static/media/DSC_4280-Pano.6185f272.jpg";